import React from 'react';
import { motion } from 'framer-motion';
export const Privacy = () => {
  return <div className="bg-white" data-id="element-431">
      <section className="py-16 md:py-24 bg-gradient-to-b from-white to-brand-light" data-id="element-432">
        <div className="container-custom" data-id="element-433">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center max-w-3xl mx-auto" data-id="element-434">
            <h1 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6" data-id="element-435">
              Privacy Policy
            </h1>
            <p className="text-gray-600" data-id="element-436">
              Last updated: {new Date().toLocaleDateString('en-GB')}
            </p>
          </motion.div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-437">
        <div className="container-custom max-w-4xl" data-id="element-438">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="prose prose-lg max-w-none" data-id="element-439">
            <h2 className="text-2xl font-bold text-brand-blue mb-4" data-id="element-440">
              Introduction
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-441">
              Daily Serve ("we", "our", or "us") is committed to protecting your
              privacy. This Privacy Policy explains how we collect, use,
              disclose, and safeguard your information when you use our
              platform.
            </p>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-442">
              Information We Collect
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-443">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-6" data-id="element-444">
              <li data-id="element-445">Account information (name, email address, password)</li>
              <li data-id="element-446">Profile information</li>
              <li data-id="element-447">Content you create or upload (tasks, messages, files)</li>
              <li data-id="element-448">
                Payment information (processed securely through our payment
                provider)
              </li>
              <li data-id="element-449">Communications with us</li>
            </ul>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-450">
              How We Use Your Information
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-451">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-6" data-id="element-452">
              <li data-id="element-453">Provide, maintain, and improve our services</li>
              <li data-id="element-454">Process transactions and send related information</li>
              <li data-id="element-455">Send technical notices, updates, and support messages</li>
              <li data-id="element-456">Respond to your comments and questions</li>
              <li data-id="element-457">Monitor and analyse trends and usage</li>
              <li data-id="element-458">Detect and prevent fraud and abuse</li>
            </ul>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-459">
              Data Security
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-460">
              We implement appropriate technical and organisational measures to
              protect your personal information against unauthorised access,
              alteration, disclosure, or destruction. This includes encryption,
              secure servers, and regular security audits.
            </p>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-461">
              Data Retention
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-462">
              We retain your information for as long as your account is active
              or as needed to provide you services. You may request deletion of
              your account and data at any time.
            </p>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-463">
              Your Rights
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-464">You have the right to:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6" data-id="element-465">
              <li data-id="element-466">Access your personal information</li>
              <li data-id="element-467">Correct inaccurate information</li>
              <li data-id="element-468">Request deletion of your information</li>
              <li data-id="element-469">Export your data</li>
              <li data-id="element-470">Opt out of marketing communications</li>
            </ul>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-471">
              Contact Us
            </h2>
            <p className="text-gray-600" data-id="element-472">
              If you have questions about this Privacy Policy, please contact us
              at{' '}
              <a href="mailto:rapeezshrestha385@gmail.com" className="text-brand-teal hover:text-brand-blue" data-id="element-473">
                rapeezshrestha385@gmail.com
              </a>
            </p>
          </motion.div>
        </div>
      </section>
    </div>;
};